<template>
  <div class="ant-pro-table">
    <a-card :body-style="{ padding: 0 }" ref="elRef">
      <div class="ant-pro-table-list-toolbar">
        <div class="ant-pro-table-list-toolbar-container">
          <div class="ant-pro-table-list-toolbar-left">
            <div class="ant-pro-table-list-toolbar-title">
              <!--              {{ title }}-->
              <a-button
                v-if="titleList.is_create"
                style="margin-left: 10px"
                type="primary"
                size="small"
                @click="handleAdd"
              >
                <plus-outlined />
                {{ titleList.addModalTitle }}
              </a-button>
            </div>
          </div>
          <div class="ant-pro-table-list-toolbar-right">
            <div class="ant-pro-table-list-toolbar-title">
              <a-button
                v-for="btn in head_btn_list"
                size="small"
                :key="btn.name"
                @click="btn.cb(search.requestParams)"
                :type="btn.clazz"
              >
                <plus-outlined v-if="btn.icon === 'plus-outlined'" />
                {{ btn.name }}
              </a-button>
            </div>
            <!--            <div class="ant-pro-table-list-toolbar-setting-item">-->
            <!--              <a-tooltip title="导出Excel">-->
            <!--                <export-excel-modal-->
            <!--                  :column-list="dynamicColumnItems"-->
            <!--                  :datasource="state.dataSource"-->
            <!--                  :filename="titleList.title"-->
            <!--                >-->
            <!--                <a-button type="primary" size="small" >下载</a-button>-->
            <!--                </export-excel-modal>-->
            <!--              </a-tooltip>-->
            <!--            </div>-->
            <a-space align="center">
              <!--              <div class="ant-pro-table-list-toolbar-setting-item">-->
              <!--                <a-tooltip title="展示全部列">-->
              <!--                  <a-switch-->
              <!--                    checked-children="全部"-->
              <!--                    un-checked-children="默认"-->
              <!--                    v-model:checked="checkAll"-->
              <!--                    @change="column_change()"-->
              <!--                  />-->
              <!--                </a-tooltip>-->
              <!--              </div>-->
              <!--              <div class="ant-pro-table-list-toolbar-setting-item">-->
              <!--                <a-tooltip title="【显示、隐藏】操作列">-->
              <!--                  <a-switch-->
              <!--                    checked-children="操作"-->
              <!--                    un-checked-children="操作"-->
              <!--                    v-model:checked="checkAction"-->
              <!--                    @change="columnAction()"-->
              <!--                  />-->
              <!--                </a-tooltip>-->
              <!--              </div>-->
            </a-space>
            <!--            <div class="ant-pro-table-list-toolbar-divider">-->
            <!--              <a-divider type="vertical" />-->
            <!--            </div>-->
            <!--            <div class="ant-pro-table-list-toolbar-setting-item">-->
            <!--              <a-tooltip title="刷新">-->
            <!--                <reload-outlined @click="handleTableChange" />-->
            <!--              </a-tooltip>-->
            <!--            </div>-->
            <!--            <div class="ant-pro-table-list-toolbar-setting-item">-->
            <!--              <a-tooltip title="密度">-->
            <!--                <a-dropdown :trigger="['click']" placement="bottomRight">-->
            <!--                  <column-height-outlined />-->
            <!--                  <template #overlay>-->
            <!--                    <a-menu-->
            <!--                      style="width: 80px"-->
            <!--                      :selected-keys="[state.tableSize]"-->
            <!--                      @click="-->
            <!--                        ({ key }) => {-->
            <!--                          state.tableSize = key;-->
            <!--                        }-->
            <!--                      "-->
            <!--                    >-->
            <!--                      <a-menu-item key="default">-->
            <!--                        <a href="javascript:">默认</a>-->
            <!--                      </a-menu-item>-->
            <!--                      <a-menu-item key="middle">-->
            <!--                        <a href="javascript:">中等</a>-->
            <!--                      </a-menu-item>-->
            <!--                      <a-menu-item key="small">-->
            <!--                        <a href="javascript:">紧凑</a>-->
            <!--                      </a-menu-item>-->
            <!--                    </a-menu>-->
            <!--                  </template>-->
            <!--                </a-dropdown>-->
            <!--              </a-tooltip>-->
            <!--            </div>-->
            <!--            <div class="ant-pro-table-list-toolbar-setting-item">-->
            <!--              <a-popover-->
            <!--                placement="bottomRight"-->
            <!--                arrowPointAtCenter-->
            <!--                trigger="click"-->
            <!--                overlayClassName="ant-pro-table-column-setting-overlay"-->
            <!--              >-->
            <!--                <template #title>-->
            <!--                  <div class="ant-pro-table-column-setting-title">-->
            <!--                    <a-checkbox-->
            <!--                      v-model:checked="columnState.checkAll"-->
            <!--                      :indeterminate="columnState.indeterminate"-->
            <!--                      @change="handleColumnAllClick"-->
            <!--                    >-->
            <!--                      列展示-->
            <!--                    </a-checkbox>-->
            <!--                    <a @click="reset">重置</a>-->
            <!--                  </div>-->
            <!--                </template>-->
            <!--                <template #content>-->
            <!--                  <span class="ant-pro-table-column-setting-list">-->
            <!--                    <drag-container-->
            <!--                      lockAxis="y"-->
            <!--                      dragClass="ant-pro-table-drag-ghost"-->
            <!--                      dropClass="ant-pro-table-drop-ghost"-->
            <!--                      @drop="({ removedIndex, addedIndex }) => move(removedIndex, addedIndex)"-->
            <!--                    >-->
            <!--                      <draggable :key="column.key" v-for="column in dynamicColumnItems">-->
            <!--                        <div class="ant-pro-table-column-setting-list-item">-->
            <!--                          <drag-icon />-->
            <!--                          <a-checkbox-->
            <!--                            :checked="column.checked"-->
            <!--                            @change="handleColumnChange($event, column)"-->
            <!--                          >-->
            <!--                            {{ column.label }}-->
            <!--                          </a-checkbox>-->
            <!--                        </div>-->
            <!--                      </draggable>-->
            <!--                    </drag-container>-->
            <!--                  </span>-->
            <!--                </template>-->
            <!--                <a-tooltip title="列设置">-->
            <!--                  <setting-outlined />-->
            <!--                </a-tooltip>-->
            <!--              </a-popover>-->
            <!--            </div>-->
            <!--            <div class="ant-pro-table-list-toolbar-setting-item">-->
            <!--              <a-tooltip :title="screenState ? '退出全屏' : '全屏'">-->
            <!--                <fullscreen-outlined v-if="!screenState" @click="setFull" />-->
            <!--                <fullscreen-exit-outlined v-else @click="exitFull" />-->
            <!--              </a-tooltip>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
      <a-table
        bordered="true"
        :scroll="{ x: columnState.tableWidth, y: 500 }"
        :row-class-name="stripe"
        :size="state.tableSize"
        :columns="dynamicColumns"
        :data-source="state.dataSource"
        :indentSize="0"
        :rowKey="'id'"
        :pagination="{
          current: state.current,
          pageSize: state.pageSize,
          total: state.total,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ['10', '20', '50', '100', '200'],
        }"
        @change="handleTableChange"
      >
        <template
          v-for="item in slotList"
          v-slot:[item.slotName]="{ index, text, record }"
          :key="item.slotName"
        >
          <span v-if="item.slotName === 'index'">
            {{ index + 1 + state.pageSize * (state.current - 1) }}
          </span>
          <span v-if="item.type === 'custom'">
            {{ item['field_' + text] }}
          </span>
          <span v-if="item.type === 'datetime'">
            {{ getDateTime(text) }}
          </span>
          <span v-if="item.type === 'date'">
            {{ getDate(text) }}
          </span>
          <span v-if="item.type === 'time'">
            {{ getTime(text) }}
          </span>
          <span v-if="item.type === 'content'">
            <span :style="item.color ? item.color(record, text) : null">
              {{ item.content ? item.content(record, text) : text }}
            </span>
          </span>
          <span v-if="item.type === 'list_render'">
            <span v-for="(data, i) in text">
              {{ data[item['field_name']] }}
              <span v-if="text?.length && i < text?.length - 1">/</span>
            </span>
          </span>
          <a-button
            style="padding-left: 1px"
            v-if="item.type === 'click'"
            type="link"
            @click="item.cb(record)"
          >
            <span v-if="item.content">
              {{ item.content(record) }}
            </span>
            <span v-else>
              {{ text }}
            </span>
          </a-button>
          <a-tag color="green" v-if="text && item.type === 'boolean'">{{ item.name1 }}</a-tag>
          <a-tag color="red" v-if="!text && item.type === 'boolean'">{{ item.name2 }}</a-tag>
          <template v-if="item.type === 'list'">
            <a-tag color="#87d068" v-for="obj in text" :key="obj.id" style="margin-bottom: 1px">
              {{ obj.name }}
            </a-tag>
          </template>
        </template>
        <template #action="{ record }">
          <a-button
            type="primary"
            size="small"
            style="margin-right: 3px"
            @click="() => handleOpenEdit(record)"
            v-if="record.is_active && titleList.is_update && !column_dropdown_btn_dict"
          >
            修改
          </a-button>
          <a-button
            size="small"
            type="danger"
            style="margin-right: 3px"
            @click="() => handleDelete(record)"
            v-if="record.is_active && titleList.is_remove && !column_dropdown_btn_dict"
          >
            {{ titleList.del_btn ? titleList.del_btn : '删除' }}
          </a-button>
          <a-button
            size="small"
            type="dashed"
            style="margin-right: 3px"
            @click="() => handleRecover(record)"
            v-if="!record.is_active && titleList.is_recover && !column_dropdown_btn_dict"
          >
            恢复
          </a-button>
          <a-button
            v-for="btn in column_normal_btn_list"
            size="small"
            v-show="btn?.is_show ? btn.is_show(record) : true"
            :disabled="btn?.disabled ? btn?.disabled(record) : false"
            :key="btn.name"
            :type="btn.clazz"
            style="margin-right: 3px; margin-top: 2px"
            @click="btn.cb(record)"
          >
            {{ btn.content ? btn.content(record) : btn.name }}
          </a-button>
          <template v-if="column_dropdown_btn_dict">
            <a-dropdown-button size="small">
              <a-button
                type="link"
                @click="column_dropdown_btn_dict.dropdown_btn.cb(record)"
                size="small"
                :disabled="
                  column_dropdown_btn_dict.dropdown_btn?.is_show
                    ? !column_dropdown_btn_dict.dropdown_btn.is_show(record)
                    : false
                "
              >
                <span
                  :style="
                    column_dropdown_btn_dict.dropdown_btn?.style
                      ? column_dropdown_btn_dict.dropdown_btn.style(record)
                      : ''
                  "
                >
                  {{ column_dropdown_btn_dict.dropdown_btn.name }}
                </span>
              </a-button>
              <template #overlay>
                <a-menu>
                  <a-menu-item
                    :key="btn.name"
                    :disabled="btn?.is_show ? !btn.is_show(record) : false"
                    @click="btn.cb(record)"
                    v-for="btn in column_dropdown_btn_dict.btn_list"
                  >
                    {{ btn.content ? btn.content(record) : btn.name }}
                  </a-menu-item>

                  <a-menu-item
                    key="update"
                    v-if="record.is_active && titleList.is_update"
                    @click="handleOpenEdit(record)"
                  >
                    <EditOutlined />
                    修改
                  </a-menu-item>
                  <a-menu-item
                    key="update"
                    v-if="record.is_active && titleList.is_remove"
                    @click="handleDelete(record)"
                  >
                    <DeleteOutlined />
                    删除
                  </a-menu-item>
                  <a-menu-item
                    key="update"
                    v-if="!record.is_active && titleList.is_recover"
                    @click="handleRecover(record)"
                  >
                    <RedoOutlined />
                    恢复
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown-button>
          </template>
        </template>
        <template #round_price="{ text }">
          {{ toFixed0(text) }}
        </template>
        <template #default_none="{ text }">
          {{ text ? text : '无' }}
        </template>
      </a-table>
    </a-card>
  </div>
  <form-modal
    v-bind="editModalAdd"
    v-if="editModalAdd.visible"
    :loading="confirmLoading"
    @cancel="
      () => {
        editModalAdd.visible = false;
      }
    "
    @ok="handlerOk"
  />
  <form-modal
    v-bind="editModalUpdate"
    v-if="editModalUpdate.visible"
    :loading="confirmLoading"
    @cancel="
      () => {
        editModalUpdate.visible = false;
      }
    "
    @ok="handlerOk"
  />
</template>

<script lang="ts">
import {
  defineComponent,
  reactive,
  ref,
  watch,
  computed,
  onActivated,
  onDeactivated,
  createVNode,
} from 'vue';
import { ExclamationCircleOutlined, PlusOutlined } from '@ant-design/icons-vue';
import { Pagination, TableFilters, TableColumn, TableColumnSortOrder } from '@/typing';
import { useFetchData } from '@/utils/hooks/useFetchData';
import { useFullscreen } from '@/utils/hooks/useFullscreen';
import { useTableDynamicColumns } from '@/utils/hooks/useTableColumn';
import FormModal from '@/components/form-modal/form-modal.vue';
import { useStore } from 'vuex';
import { message, Modal } from 'ant-design-vue';
import getPageConfig from '@/components/page-model2/index';
import { Record } from '@/components/page-model/typing';
import { isNumber } from 'lodash';
import bus from '@/utils/bus';

export default defineComponent({
  name: 'PageModel2',
  props: {
    modalType: {
      type: String,
      required: true,
    },
    search: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    activeKey: {
      type: String,
      required: true,
    },
    isReloadPage: {
      type: Boolean,
    },
  },
  setup(props: any, { emit }: any) {
    const confirmLoading = ref<boolean>(false);
    const store = useStore();
    const event_bus = bus;
    const current_org = store.getters['user/current_org'];
    const checkAll = ref<boolean>(false);
    const checkAction = ref<boolean>(false);
    let formModalUpdate = false; // 判断显示创建、修改

    // 时间区间格式转化 数组-->字符串
    const getRangePicker = (api_fields: Record, record: Record) => {
      const obj: any = {};
      for (const key in api_fields) {
        if (record[api_fields[key] as string]) {
          obj[key] = record[api_fields[key] as string].join(',');
        }
      }
      return obj;
    };

    // 操作列 按钮分为下拉和普通
    const column_normal_btn_list: any = computed(() => {
      return btn_list?.filter((item: any) => item.type == undefined || item.type == 'btn');
    });
    const column_dropdown_btn_dict: any = computed(() => {
      const l = btn_list?.filter((item: any) => item.type == 'dropdown');
      if (l && l.length > 0) {
        return { dropdown_btn: l[0], btn_list: l.slice(1) };
      } else {
        return null;
      }
    });

    const {
      searchConfig,
      searchConfigOptions,
      formModalConfig,
      formModalConfigOptions,
      updateFormModalConfig,
      updateFormModalConfigOptions,
      queryData,
      addData,
      updateData,
      removeData,
      recoverData,
      baseColumns,
      slotList,
      titleList,
      api_fields,
      btn_list,
      head_btn_list,
      event_obj,
    } = getPageConfig(props.modalType);

    if (searchConfig.fields) {
      for (let i = 0; i < searchConfig.fields.length; i++) {
        // 预先填充 placeholder
        let filed_dict = searchConfig.fields[i];
        if (!filed_dict.placeholder) {
          let pre_str = filed_dict.type == 'input' ? '请填写' : '请选择';
          filed_dict.placeholder = pre_str + filed_dict.label;
        }

        // 预先填充 校验message
        let search_rule_dict = searchConfig.rules[filed_dict.name];
        if (search_rule_dict) {
          if (!search_rule_dict.message) {
            search_rule_dict.message = filed_dict.placeholder;
          }
        }
      }
    }

    if (formModalConfig.fields) {
      for (let i = 0; i < formModalConfig.fields.length; i++) {
        let filed_dict = formModalConfig.fields[i];
        if (!filed_dict.placeholder) {
          let pre_str = filed_dict.type == 'input' ? '请填写' : '请选择';
          filed_dict.placeholder = pre_str + filed_dict.label;
        }
      }
    }

    const {
      state: columnState,
      dynamicColumns,
      dynamicColumnItems,
      handleColumnAllClick,
      handleColumnChange,
      reset,
      move,
    } = useTableDynamicColumns(baseColumns as TableColumn[], {
      checkAll: false,
      needRowIndex: false,
    });
    const [elRef, screenState, { setFull, exitFull }] = useFullscreen();
    // const { resetFields, validateInfos } = useForm(searchConfig.model, searchConfig.rules);

    const {
      stripe,
      reload,
      setPageInfo,
      context: state,
    } = useFetchData(queryData, {
      ...props.search,
    });
    const handleTableChange = (
      { current, pageSize }: Pagination,
      filters: TableFilters,
      sorter: TableColumnSortOrder,
    ) => {
      console.log(sorter);
      let filter_map: any = {};
      for (let key in filters) {
        if (filters[key]) {
          filter_map[key] = filters[key].map((x: any) => x.toString()).join(',');
        }
      }
      setPageInfo({
        current,
        pageSize,
        ...props.search.requestParams,
        ...filter_map,
      });
      reload();
    };

    watch(
      () => props.activeKey,
      () => {
        if (props.activeKey == props.title) {
          reload();
        }
      },
    );
    watch(
      () => props.isReloadPage,
      () => {
        if (props.isReloadPage) {
          if (props.activeKey == props.title) {
            reload();
            emit('reloadPageFinish');
          }
        }
      },
    );

    const event_obj_refresh = () => {
      reload();
    };
    event_obj?.on('refresh', event_obj_refresh);
    event_bus?.on('refresh_basic', event_obj_refresh);

    onActivated(() => {
      reload();
      event_obj?.off('refresh', event_obj_refresh);
      event_bus?.off('refresh_basic', event_obj_refresh);
      // 先解监听，再监听，防止重复
      event_obj?.on('refresh', event_obj_refresh);
      event_bus?.on('refresh_basic', event_obj_refresh);
    });
    onDeactivated(() => {
      event_obj?.off('refresh', event_obj_refresh);
      event_bus?.off('refresh_basic', event_obj_refresh);
    });
    // edit
    const editModalAdd = reactive({
      visible: false,
      title: '',
      form: formModalConfig,
      options: formModalConfigOptions,
    });
    const editModalUpdate = reactive({
      visible: false,
      title: '',
      form: updateFormModalConfig,
      options: updateFormModalConfigOptions,
    });
    let currentRecord = reactive({ name: '' });
    const handleOpenEdit = (record: any) => {
      formModalUpdate = true;
      editModalUpdate.visible = true;
      editModalUpdate.title = titleList.updateTitle;
      editModalUpdate.form.model = {
        ...updateFormModalConfig.model,
        ...record,
        ...getObjList(api_fields.update, record),
      };

      currentRecord = record;
    };
    const handleAdd = () => {
      formModalUpdate = false;
      editModalAdd.visible = true;

      editModalAdd.form.model = { ...formModalConfig.model };
      editModalAdd.title = titleList.addModalTitle;
    };

    const handleDelete = (record: any) => {
      Modal.confirm({
        title: `是否${titleList.del_btn ? titleList.del_btn : '删除'}此项记录?`,
        icon: createVNode(ExclamationCircleOutlined),
        onOk() {
          return new Promise(resolve => {
            removeData({
              org_id: current_org.id,
              ...getObjList(api_fields.delete, record),
            }).then((res: any) => {
              message.success(`${titleList.del_btn ? titleList.del_btn : '删除'}成功`);
              Object.assign(record, res);
              resolve(null);
            });
          }).catch(() => console.log('Oops errors!'));
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onCancel() {},
      });
      // removeData({
      //   org_id: current_org.id,
      //   ...getObjList(api_fields.delete, record),
      // }).then((res: any) => {
      //   message.success('删除成功');
      //   Object.assign(record, res);
      // });
    };
    const handleRecover = (record: any) => {
      recoverData({
        org_id: current_org.id,
        ...getObjList(api_fields.recover, record),
      }).then((res: any) => {
        message.success('恢复成功');
        Object.assign(record, res);
      });
    };

    const handlerOk = (data: any) => {
      confirmLoading.value = true;
      if (!formModalUpdate) {
        addData({ ...data })
          .then(() => {
            message.success('创建成功');
            reload();
            editModalAdd.visible = false;
          })
          .finally(() => {
            confirmLoading.value = false;
            console.error('finally ');
          });
      } else {
        updateData({
          ...data,
          ...getObjList(api_fields.updateData, data),
          ...getObjList(api_fields.updateData, editModalUpdate.form.model),
        })
          .then((res: any) => {
            Object.assign(currentRecord, res);
            message.success('修改成功');
            editModalUpdate.visible = false;
            formModalUpdate = false;
          })
          .finally(() => {
            confirmLoading.value = false;
            console.error('finally ');
          });
      }
    };

    // 字段对应错误————>转化正确
    const getObjList = (api_fields: Record, record: Record) => {
      const obj: any = {};
      for (const key in api_fields) {
        if (record[api_fields[key] as string]) {
          obj[key] = record[api_fields[key] as string];
        }
      }
      return obj;
    };

    // 接口返回时间，格式优化
    const getDateTime = (time: any) => {
      if (time && new Date().getFullYear().toString() == time.substring(0, 4)) {
        time = time.substring(0, 16);
      } else if (time) {
        time = time.substring(0, 16);
      }
      return time;
    };
    const getDate = (time: any) => {
      if (time && new Date().getFullYear().toString() == time.substring(0, 4)) {
        time = time.substring(0, 10);
      } else if (time) {
        time = time.substring(0, 10);
      }
      return time;
    };
    const getTime = (time: any) => {
      if (time) {
        time = time.substring(0, 5);
      }
      return time;
    };

    // 列’默认‘ ’全部‘ 展示的切换
    let old_list: any[] = []; // 定义old_list记录默认数据
    const column_change = () => {
      if (checkAll.value) {
        dynamicColumnItems.value.forEach(org => {
          old_list.push(org);
          let b = {
            ...org,
            checked: true,
          };
          let a: any = {};
          a.target = b;
          handleColumnChange(a, b);
        });
      } else {
        old_list.forEach(org => {
          let a: any = {};
          a.target = org;
          handleColumnChange(a, org);
        });
      }
    };
    const columnAction = () => {
      dynamicColumnItems.value.forEach(org => {
        if (org.key == 'action') {
          let b = {
            ...org,
            checked: checkAction.value,
          };
          let a: any = {};
          a.target = b;
          handleColumnChange(a, b);
        }
      });
    };
    const toFixed0 = (num: any) => {
      if (isNumber(num)) {
        if (Number(num.toFixed(0)) == 0) {
          return 0;
        } else {
          return num.toFixed(0);
        }
      } else {
        return '';
      }
    };
    return {
      toFixed0,
      getDateTime,
      getTime,
      getDate,
      getRangePicker,
      column_change,
      columnAction,
      checkAll,
      checkAction,
      slotList,
      titleList,
      // tableHeight,
      state,
      stripe,
      columnState,
      dynamicColumns,
      dynamicColumnItems,
      column_normal_btn_list,
      column_dropdown_btn_dict,

      handleAdd,
      handlerOk,
      confirmLoading,
      currentRecord,
      // fullscreen
      elRef,
      screenState,
      setFull,
      exitFull,

      handleTableChange,

      handleColumnChange,
      handleColumnAllClick,
      reset,
      move,
      current_org,
      message,
      // edit
      editModalAdd,
      editModalUpdate,
      handleOpenEdit,
      handleDelete,
      handleRecover,
      reload,
      getPageConfig,
      searchConfig,
      searchConfigOptions,
      formModalConfig,
      formModalConfigOptions,
      updateFormModalConfig,
      updateFormModalConfigOptions,
      getObjList,
      api_fields,
      btn_list,
      head_btn_list,
    };
  },
  components: {
    PlusOutlined,
    FormModal,
  },
});
</script>
